<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import { pick } from 'lodash'
import { mapActions, mapState } from 'vuex'
import { getManagerTypeLabel } from '@/helpers'

export default {
  components: { Breadcrumbs },
  computed: {
    ...mapState('accountant', ['accountants']),
    ...mapState('manager', ['managers']),
    ...mapState('education_manager', ['educationManagers']),
    ...mapState('super_admin', ['superAdmins']),
    recordId() {
      return this.$route.params.id
    },
    managerType() {
      const pathname = this.$route.path
      if (pathname.includes('accountant')) {
        return 'accountant'
      }
      if (pathname.includes('education-manager')) {
        return 'education_manager'
      }
      if (pathname.includes('super-admin')) {
        return 'super_admin'
      }
      return 'manager'
    },
    managerTitle() {
      return getManagerTypeLabel(this.managerType)
    },
    title() {
      return (this.recordData || {}).name
    },
    recordData() {
      if (this.managerType === 'accountant') {
        return this.accountants.find(item => item.id === this.recordId)
      } else if (this.managerType === 'education_manager') {
        return this.educationManagers.find(item => item.id === this.recordId)
      } else if (this.managerType === 'super_admin') {
        return this.superAdmins.find(item => item.id === this.recordId)
      } else {
        return this.managers.find(item => item.id === this.recordId)
      }
    }
  },
  data() {
    return {
      formData: {
        user: {}
      }
    }
  },
  methods: {
    ...mapActions('accountant', ['fetchAccountant', 'updateAccountant', 'removeAccountant']),
    ...mapActions('super_admin', ['fetchSuperAdmin', 'updateSuperAdmin', 'removeSuperAdmin']),
    ...mapActions('education_manager', [
      'fetchEducationManager',
      'updateEducationManager',
      'removeEducationManager'
    ]),
    ...mapActions('manager', ['fetchManager', 'updateManager', 'removeManager']),
    async onClickUpdateAccountant() {
      if (this.managerType === 'accountant') {
        await this.updateAccountant({ id: this.recordId, params: this.formData })
      } else if (this.managerType === 'education_manager') {
        await this.updateEducationManager({ id: this.recordId, params: this.formData })
      } else if (this.managerType === 'super_admin') {
        await this.updateSuperAdmin({ id: this.recordId, params: this.formData })
      } else {
        await this.updateManager({ id: this.recordId, params: this.formData })
      }
      this.$alert.success('Cập nhật thành công')
    },
    async onClickDeleteAccountant() {
      this.$dialog.confirm({
        title: 'Xác nhận xóa người dùng',
        text: ` Xác có chắc chắn muốn xóa người dùng, dữ liệu bị xóa sẽ không thể khôi phục`,
        okText: 'Đúng Vậy',
        cancelText: 'Hủy',
        done: async () => {
          if (this.managerType === 'accountant') {
            await this.removeAccountant({ id: this.recordId })
          } else if (this.managerType === 'education_manager') {
            await this.removeEducationManager({ id: this.recordId })
          } else if (this.managerType === 'super_admin') {
            await this.removeSuperAdmin({ id: this.recordId })
          } else {
            await this.removeManager({ id: this.recordId })
          }

          this.$alert.success('Xóa thành công')
          this.$router.push('/managers')
        }
      })
    }
  },
  created() {
    if (!this.recordId) {
      return
    }
    if (this.managerType === 'accountant') {
      this.fetchAccountant({ id: this.recordId })
    } else if (this.managerType === 'education_manager') {
      this.fetchEducationManager({ id: this.recordId })
    } else if (this.managerType === 'super_admin') {
      this.fetchSuperAdmin({ id: this.recordId })
    } else {
      this.fetchManager({ id: this.recordId })
    }
  },
  watch: {
    recordData(v) {
      if (!v) {
        this.formData = { user: {} }
      }
      this.formData.user = pick(v.user, ['username', 'email'])
      this.formData.phone = v.phone
      this.formData.name = v.name
    }
  }
}
</script>
<template>
  <div>
    <div class="d-flex justify-space-between align-center pa-4 pa-md-2">
      <div>
        <Breadcrumbs
          :headline="title"
          :link="[{ text: this.managerTitle, href: '/managers?type=' + this.managerType }]"
        />
      </div>

      <div class="d-flex">
        <v-btn @click="onClickUpdateAccountant" medium color="primary">
          <span>Lưu</span>
        </v-btn>
        <v-btn @click="onClickDeleteAccountant" medium class="ml-2" color="error">
          <span>Xóa</span>
        </v-btn>
      </div>
    </div>
    <v-card v-if="recordData" class="pa-2 record-form">
      <v-text-field disabled v-model="formData.user.username" label="Mã NV" />
      <v-text-field v-model="formData.name" label="Tên" />
      <v-text-field v-model="formData.user.email" label="Email" />
      <v-text-field v-model="formData.phone" label="SĐT" />
    </v-card>
  </div>
</template>
<style scoped>
.record-form {
  width: 600px;
}
</style>
